import React, { FunctionComponent, useEffect } from 'react';

import FullPageWrapper from 'scenes/common/components/FullPageWrapper/FullPageWrapper';

import { FooterTop } from 'scenes/common/components/Footer';
import { ScheduledMaintenance } from 'scenes/outage/components/ScheduledMaintenance';

import {
  financialServiceGuide,
  keyFactSheet,
  privacyPolicyInfo,
  productDisclosureStatement,
  termsAndConditions,
} from 'scenes/common/helpers/contacts';
import { InsuranceName } from 'scenes/common/types';
import { OutageProps } from 'scenes/outage/types';
import withOutage from 'scenes/outage/components/HOC/withOutage';

export const informationLinks = [
  financialServiceGuide,
  keyFactSheet,
  productDisclosureStatement,
  termsAndConditions,
  privacyPolicyInfo,
];

const ScheduledMaintenanceFullPage: FunctionComponent<OutageProps> = ({
  funnelState,
}) => {
  useEffect(() => {
    document.title = `Scheduled Maintenance | Coles Insurance`;
  }, []);

  return (
    <FullPageWrapper
      onClickCallUs={() => {}}
      isLoading={false}
      Footer={() => (
        <FooterTop
          quoteNumber=""
          pageNotLoadingOrError={false}
          showQuoteInformation={false}
          showFooterQuoteInformation={false}
          showFlybuys={false}
          showMarketingCampaign={false}
          informationLinks={informationLinks}
          insuranceName={InsuranceName.Car}
        />
      )}
    >
      <ScheduledMaintenance
        onClickCallUs={() => {}}
        funnelState={funnelState}
      />
    </FullPageWrapper>
  );
};

export default withOutage(ScheduledMaintenanceFullPage);
